'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CwNotificationStatus = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwImage = require('../cwimage/CwImage');

var _CwImage2 = _interopRequireDefault(_CwImage);

var _CwNotification = require('./CwNotification.scss');

var _CwNotification2 = _interopRequireDefault(_CwNotification);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _IconPath = require('../../utils/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwNotificationStatus = exports.CwNotificationStatus = {
  ERROR: 'Error',
  INFORMATIONAL: 'Informational',
  WARNING: 'Warning',
  SUCCESSFUL: 'Successful'
};

var CwNotification = function CwNotification(props) {
  var _cx;

  var wrapClass = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _CwNotification2.default.wrap, true), (0, _defineProperty3.default)(_cx, props.className, props.className), (0, _defineProperty3.default)(_cx, _CwNotification2.default.error, props.status === CwNotificationStatus.ERROR), (0, _defineProperty3.default)(_cx, _CwNotification2.default.informational, props.status === CwNotificationStatus.INFORMATIONAL), (0, _defineProperty3.default)(_cx, _CwNotification2.default.warning, props.status === CwNotificationStatus.WARNING), (0, _defineProperty3.default)(_cx, _CwNotification2.default.successful, props.status === CwNotificationStatus.SUCCESSFUL), _cx));

  return _react2.default.createElement(
    'div',
    { onFocus: props.onFocus,
      onBlur: props.onBlur,
      'data-cwid': props.cwId,
      style: props.style,
      className: wrapClass },
    _react2.default.createElement(
      'div',
      { className: _CwNotification2.default.content },
      _react2.default.createElement(_CwImage2.default, { src: props.statusIcon, className: _CwNotification2.default.icon }),
      _react2.default.createElement(
        'div',
        { className: _CwNotification2.default.text },
        props.message
      ),
      _react2.default.createElement(_CwImage2.default, { src: props.closeIcon, className: _CwNotification2.default.closeIcon, onClick: props.onClose })
    ),
    props.children ? _react2.default.createElement(
      'div',
      { className: _CwNotification2.default.children },
      props.children
    ) : null
  );
};

CwNotification.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  status: _propTypes2.default.oneOf([CwNotificationStatus.ERROR, CwNotificationStatus.INFORMATIONAL, CwNotificationStatus.WARNING, CwNotificationStatus.SUCCESSFUL]).isRequired,
  statusIcon: _propTypes2.default.string.isRequired,
  closeIcon: _propTypes2.default.string,
  message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element.isRequired]),
  onClose: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.element), _propTypes2.default.element])
};

CwNotification.defaultProps = {
  closeIcon: _IconPath2.default.get('Action_Close')
};

exports.default = CwNotification;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwnotification/CwNotification.js
// module id = 842
// module chunks = 10